import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListOnboardingChallengesV1Response } from './list-onboarding-challenges-v1-response';
import { listOnboardingChallengesV1ResponseSchema } from './list-onboarding-challenges-v1-response';

export async function listOnboardingChallengesV1Api(): Promise<
  IValidatedResponse<IListOnboardingChallengesV1Response>
> {
  return getRequest<IListOnboardingChallengesV1Response>({
    path: '/sys/challenges/v1/onboarding',
    schema: listOnboardingChallengesV1ResponseSchema,
  });
}
